export const required = value =>
  value || typeof value === 'number' ? undefined : 'REQUIRED';

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,9}$/i.test(value)
    ? 'INVALID_EMAIL_ADDRESS'
    : undefined;

export const phoneNumber = value =>
  value && !/^(0|[1-9][\d]{10})$/i.test(value)
    ? 'Invalid phone number, must be 11 digits'
    : undefined;

export const universalPhoneNumber = value =>
  !/^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/i.test(value)
    ? 'Invalid phone number'
    : undefined;

export const minLength = min => value =>
  value && value.length < min ? `MUST_BE_${min}_CHARACTERS_OR_MORE` : undefined;

export const containsLetters = value =>
  value && !/[a-z]+/i.test(value) ? 'MUST_BE_CONTAINS_LETTERS' : undefined;

export const containsNumbers = value =>
  value && !/[\d]+/i.test(value) ? 'MUST_BE_CONTAINS_NUMBER' : undefined;

export const isNumber = value =>
  value && Number.isNaN(+value) ? 'MUST_BE_NUMERIC' : undefined;
export const isPositive = value =>
  value && +value <= 0 ? 'MUST_BE_POSITIVE' : undefined;

export const passwordMatch = (value, values) =>
  values.password &&
  values.new_password &&
  values.password === values.new_password
    ? undefined
    : 'PASSWORD_DO_NOT_MATCH';
export const minLength4 = minLength(4);
export const minLength7 = minLength(7);
export const minLength6 = minLength(6);

export const validDate = value =>
  !value || !/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(value)
    ? 'INVALID_DATE'
    : undefined;

export const requiredArr = value =>
  value && !!value.length ? undefined : 'REQUIRED';

export const requiredOneIs = value => value2 =>
  (value && !!value.length) || (value2 && value2.length)
    ? undefined
    : 'REQUIRED';

export const unacceptableSigns = value =>
  value && /[ /\\]+/i.test(value) ? 'UNACCEPTABLE_SIGNS' : undefined;

// Валидация для названия категории: только заглавные латинские буквы и цифры
export const categoryName = value => {
  if (!value) return undefined;

  return /^[A-Z0-9]+$/.test(value) ? undefined : 'CATEGORY_NAME_VALIDATION';
};
